var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ai-agent-container",
      staticStyle: { position: "relative", height: "100%", padding: "10px" },
    },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            title: (_vm.form.id ? "編輯" : "新增") + _vm.funcName,
            visible: _vm.dialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": _vm.formLabelWidth },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "場域名稱",
                        prop: "siteName",
                        rules: [
                          {
                            required: true,
                            message: "請輸入場域名稱",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.siteName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "siteName", $$v)
                          },
                          expression: "form.siteName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "場域代碼",
                        prop: "code",
                        rules: [
                          {
                            required: true,
                            message: "請輸入場域代碼",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "code", $$v)
                          },
                          expression: "form.code",
                        },
                      }),
                      _c("i", [_vm._v("產生金鑰的代碼")]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "場域金鑰(存檔後產生)", prop: "secret" },
                    },
                    [
                      _c("el-input", {
                        attrs: { readonly: "" },
                        model: {
                          value: _vm.form.secret,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "secret", $$v)
                          },
                          expression: "form.secret",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Assistants ID",
                        prop: "assistantsID",
                        rules: [
                          {
                            required: true,
                            message: "請輸入 Assistants ID",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.assistantsID,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "assistantsID", $$v)
                          },
                          expression: "form.assistantsID",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "狀態" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "啟用",
                          "inactive-text": "停用",
                        },
                        model: {
                          value: _vm.form.isEnabled,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isEnabled", $$v)
                          },
                          expression: "form.isEnabled",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("虛擬人介面設定"),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "靜態圖片 URL" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "JPG / PNG / GIF 網址" },
                        model: {
                          value: _vm.form.idleImageUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "idleImageUrl", $$v)
                          },
                          expression: "form.idleImageUrl",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "開場影片 URL" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "進站自動播放影片網址" },
                        model: {
                          value: _vm.form.openingVideoUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "openingVideoUrl", $$v)
                          },
                          expression: "form.openingVideoUrl",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "回答影片 URL" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "AI 回答中循環影片網址" },
                        model: {
                          value: _vm.form.replyVideoUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "replyVideoUrl", $$v)
                          },
                          expression: "form.replyVideoUrl",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveBasicData },
                },
                [_vm._v("確 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            title: "聊天室設定 - " + (_vm.form.siteName || "未命名場域"),
            visible: _vm.chatDialogVisible,
            width: "80%",
            top: "3vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.chatDialogVisible = $event
            },
          },
        },
        [
          _c("el-alert", {
            attrs: {
              title: "所有欄位皆為選填；未填時前台將沿用目前預設內容。",
              type: "info",
              closable: false,
              "show-icon": "",
            },
          }),
          _c(
            "div",
            { staticClass: "chatroom-grid" },
            [
              _c("div", { staticClass: "chatroom-grid__header header-item" }, [
                _vm._v("項目"),
              ]),
              _vm._l(_vm.languageOptions, function (lang) {
                return _c(
                  "div",
                  {
                    key: "header-" + lang.code,
                    staticClass: "chatroom-grid__header",
                  },
                  [_vm._v(" " + _vm._s(lang.label) + " ")]
                )
              }),
              _vm._l(_vm.chatroomRows, function (row) {
                return [
                  _c(
                    "div",
                    {
                      key: row.key + "-label",
                      staticClass: "chatroom-grid__label",
                    },
                    [_vm._v(" " + _vm._s(row.label) + " ")]
                  ),
                  _vm._l(_vm.languageOptions, function (lang) {
                    return _c(
                      "div",
                      {
                        key: row.key + "-" + lang.code,
                        staticClass: "chatroom-grid__cell",
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: row.type || "text",
                            rows: row.rows || 2,
                            resize: "vertical",
                            placeholder: lang.label,
                          },
                          model: {
                            value: row.model[lang.code],
                            callback: function ($$v) {
                              _vm.$set(row.model, lang.code, $$v)
                            },
                            expression: "row.model[lang.code]",
                          },
                        }),
                      ],
                      1
                    )
                  }),
                ]
              }),
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.chatDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveChatroomData },
                },
                [_vm._v("儲 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            title: "查看紀錄",
            visible: _vm.dialogVisibleByChatLog,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleByChatLog = $event
            },
          },
        },
        [
          _c(
            "el-card",
            {
              staticClass: "box-card",
              staticStyle: { overflow: "auto", height: "calc(70vh + 15px)" },
            },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  attrs: {
                    size: "mini",
                    data: _vm.listByChatLog,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    height: "calc(70vh - 80px)",
                    "overflow-x": "auto",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", label: "項次", width: "60" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.$index + 1))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      label: "QA的日期時間",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.createdTime))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      label: "Q的問題",
                      "min-width": "250",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.questions))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "left",
                      label: "A的答案",
                      "min-width": "250",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(" " + _vm._s(scope.row.answers) + " ")]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.total > 0,
                    expression: "total > 0",
                  },
                ],
                attrs: {
                  layout: "prev, pager, next",
                  total: _vm.total,
                  page: _vm.listQueryByChatLog.page,
                  limit: _vm.listQueryByChatLog.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.listQueryByChatLog, "page", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.listQueryByChatLog, "limit", $event)
                  },
                  pagination: function ($event) {
                    return _vm.getChatLogsByAIAgentId(_vm.dialogRowIdByChatLog)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.listLoading, type: "success" },
                  on: {
                    click: function ($event) {
                      return _vm.exportToExcelByChatLog(
                        _vm.dialogRowIdByChatLog
                      )
                    },
                  },
                },
                [_vm._v("下載Excel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.listLoading },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisibleByChatLog = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            title: "虛擬人介面設定",
            visible: _vm.dialogVisibleByDefaultSetting,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleByDefaultSetting = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                { ref: "form", attrs: { model: _vm.formByDefaultSetting } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "靜態圖片 URL" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "JPG / PNG / GIF 網址" },
                        model: {
                          value: _vm.formByDefaultSetting.idleImageUrl,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formByDefaultSetting,
                              "idleImageUrl",
                              $$v
                            )
                          },
                          expression: "formByDefaultSetting.idleImageUrl",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "開場影片 URL" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "進站自動播放影片網址" },
                        model: {
                          value: _vm.formByDefaultSetting.openingVideoUrl,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formByDefaultSetting,
                              "openingVideoUrl",
                              $$v
                            )
                          },
                          expression: "formByDefaultSetting.openingVideoUrl",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "回答影片 URL" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "AI 回答中循環影片網址" },
                        model: {
                          value: _vm.formByDefaultSetting.replyVideoUrl,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formByDefaultSetting,
                              "replyVideoUrl",
                              $$v
                            )
                          },
                          expression: "formByDefaultSetting.replyVideoUrl",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "APP AI" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "APP AI網址" },
                        model: {
                          value: _vm.formByDefaultSetting.appAiUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.formByDefaultSetting, "appAiUrl", $$v)
                          },
                          expression: "formByDefaultSetting.appAiUrl",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "WEB AI" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "WEB AI網址" },
                        model: {
                          value: _vm.formByDefaultSetting.webAiUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.formByDefaultSetting, "webAiUrl", $$v)
                          },
                          expression: "formByDefaultSetting.webAiUrl",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "success", disabled: _vm.listLoading },
                  on: { click: _vm.saveByDefaultSetting },
                },
                [_vm._v(" 保 存 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", disabled: _vm.listLoading },
                  on: { click: _vm.closeByDefaultSetting },
                },
                [_vm._v(" 關 閉 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { padding: "20px", "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            {
              staticStyle: {
                display: "flex",
                "align-items": "flex-end",
                gap: "0 8px",
              },
              attrs: { "label-position": "left" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "場域查詢" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "輸入場域名稱" },
                    model: {
                      value: _vm.listQuery.search,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "search", $$v)
                      },
                      expression: "listQuery.search",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "狀態" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "請選擇狀態" },
                      model: {
                        value: _vm.listQuery.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.listQuery, "status", $$v)
                        },
                        expression: "listQuery.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "啟用", value: true },
                      }),
                      _c("el-option", {
                        attrs: { label: "停用", value: false },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.getList } },
                    [_vm._v("查詢")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      loading: _vm.listLoading,
                      type: "success",
                      icon: "el-icon-refresh-left",
                      circle: "",
                    },
                    on: { click: _vm.refresh },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.handleCreate },
                    },
                    [_vm._v("新增" + _vm._s(_vm.funcName))]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "warning" },
                      on: { click: _vm.handleDefaultSetting },
                    },
                    [_vm._v("預設虛擬人介面")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "場域名稱",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.siteName))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "場域代碼",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.code))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "場域金鑰(存檔後產生)",
                  "min-width": "300",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          { attrs: { effect: "dark", type: "danger" } },
                          [_vm._v(_vm._s(scope.row.secret))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "Assistants ID",
                  "min-width": "300",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          { attrs: { effect: "dark", type: "info" } },
                          [_vm._v(_vm._s(scope.row.assistantsID))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "狀態", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.isEnabled ? "success" : "danger",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.isEnabled ? "啟用" : "停用") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "建立日期", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.createDate))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "更新日期", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.updateDate))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作", width: "360" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "warning" },
                            on: {
                              click: function ($event) {
                                return _vm.handleChatLog(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看紀錄")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("編輯")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.handleChatroom(scope.row)
                              },
                            },
                          },
                          [_vm._v("聊天室設定")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("刪除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0" },
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }